export default[
  {
    path: '/dataList/shopBill',
    component: resolve => require(['../page.vue'], resolve),
    meta: {
        title: '收支账',
        authLogin: true
    }
  },
  {
    path: '/dataList/shopBill/shopGrantDetail',
    component: resolve => require(['../shopGrantDetail.vue'], resolve),
    meta: {
        title: '门店应发明细',
        authLogin: true
    }
  },
  {
    path: '/dataList/shopBill/staffGrantDetail',
    component: resolve => require(['../staffGrantDetail.vue'], resolve),
    meta: {
        title: '店员应发明细',
        authLogin: true
    }
  },
]